import {OCSelectOptionType} from '../BasicOcComponents/OcAutocompleteSelect'
import {OcTextFieldLineType} from '../BasicOcComponents/OcTextFields'
import {ValidationResult} from '../Validation'
import {
    OcGenericDialogCustomEditorProps,
    OcGenericDialogOutput,
    OcGenericDialogStatus,
    OcGenericDialogFieldType
} from './OcGenericDialogInterfacesExport'

export const xlBreakpoint = 1565
export const lgBreakpoint = 1140
export const mdBreakpoint = 768
export const smBreakpoint = 377

export type OcGenericDialogFieldWidth = 1 | 2 | 3 | 4 | 5 | 6

export interface OcGenericDialogFieldBaseProps<SourceType, FieldType, CustomPropsType = Record<string, unknown>> {
    /** Index used for sorting fields in group. */
    index: number
    /** If filled, it will be displayed as label in inputs. */
    label?: string
    /** Size of the component in the group row. */
    width?: OcGenericDialogFieldWidth
    /** Type of the field */
    type: OcGenericDialogFieldType
    /** If mandatory, '*' is displayed in label and field cannot be empty. */
    mandatory?: boolean
    /** Text displayed as error when field is mandatory and empty */
    mandatoryErrorText?: string
    /** Disable field component. */
    disabled?: boolean
    /** Disable button for reseting changes. */
    disableReset?: boolean
    /** Callback to get value of this field.
     * Defaults to (data) => data[field]
     */
    getValue?(data: SourceType): FieldType | undefined
    /** Callback to set value of this field.
     * In default status is not considered.
     * Defaults to 'data[field] = deepClone(value)'
     */
    setValue?(
        data: SourceType,
        value?: FieldType,
        dialogOutput?: OcGenericDialogOutput[],
        status?: OcGenericDialogStatus
    ): void
    /** Validation function for value. */
    validateValue?(value: FieldType | undefined, dialogOutput: OcGenericDialogOutput[]): ValidationResult
    customEditor?: {
        additionalProps: CustomPropsType
        editor: React.ComponentType<OcGenericDialogCustomEditorProps<FieldType> & CustomPropsType>
    }
    /** Allow decimal for number input */
    allowDecimal?: boolean
    /** Number of allowed deciaml places - value will be formatted according it. */
    decimalPlaces?: number
    /** Minimal value for number.
     * Default is 0.
     */
    minValue?: number
    /** Maximal value for number */
    maxValue?: number
    /** Number to increase/decrease the value using the input arrows/spinner. */
    changeStep?: number
    /** Options for autocompleteSelect and for radio button group. */
    suggestions?: OCSelectOptionType[]
    /** Display message when no possible options in list. */
    noOptionsMessage?: string
    /** Helper text for textfield inputs. */
    helperText?: string
    /** Allow select multiple values. */
    multiSelect?: boolean
    /** Default value is used in create mode as initial value. */
    defaultValue?: FieldType
    /** Placeholder text for textfield inputs. */
    placeholder?: string
    /** Line type (single, multi, area) from OcTextfield. Default value is single. */
    lineType?: OcTextFieldLineType
    /** Maximum number of rows for textfield. */
    maxRows?: number
    /** Minimum number of rows for textfield. Default value is 1. */
    minRows?: number
    /** Latest date that a user can select, in ISO 8601 date format. */
    maxDate?: string
    /** Earliest date that a user can select, in ISO 8601 date format. */
    minDate?: string
    /**Porperty to restrict input to date without time. In this case, the `minDate` and `maxDate` should be in "YYYY-MM-DD" format */
    dateOnly?: boolean
    /** Combine function to combine complex values from different data objects in bulkEdit mode, to determine initial value.
     * Loops thru all data objects in bulkEdit, if returned 'undefined', loop stops.*/
    combineItemsFunc?: (item1: FieldType, item2: FieldType) => FieldType | undefined
    /** Function to determine, if the field should be displayed. As input is passed array of all existing fields.
     * Group is displayed when at least one field should be displayed. */
    displayCondition?: (dialogOutput: OcGenericDialogOutput[]) => boolean
    /** Allowed types for Dropzone */
    allowedTypes?: string[]
}
